import { defineMessages } from 'react-intl';

export const ar = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_ar',
  },
});

export const da = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_da',
  },
});

export const de = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_de',
  },
});

export const el = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_el',
  },
});

export const en = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_en',
  },
});

export const en_us = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_en_us',
  },
});

export const es = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_es',
  },
});

export const es_mx = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_es_mx',
  },
});

export const fa = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_fa',
  },
});

export const fr = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_fr',
  },
});

export const he = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_he',
  },
});

export const hi = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_hi',
  },
});

export const id = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_id',
  },
});

export const is = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_is',
  },
});

export const it = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_it',
  },
});

export const jp_full = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_jp_full',
  },
});

export const jp_romaji = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_jp_romaji',
  },
});

export const ko = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_ko',
  },
});

export const mn = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_mn',
  },
});

export const nl = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_nl',
  },
});

export const no = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_no',
  },
});

export const pl = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_pl',
  },
});

export const pt = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_pt',
  },
});

export const pt_br = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_pt_br',
  },
});

export const ru = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_ru',
  },
});

export const sl = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_sl',
  },
});

export const sv = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_sv',
  },
});

export const sw = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_sw',
  },
});

export const th = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_th',
  },
});

export const tr = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_tr',
  },
});

export const uk = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_uk',
  },
});

export const yo = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_yo',
  },
});

export const zh_cn = defineMessages({
  coursePageBreadcrumb: {
    id: 'seo_navigation_course_zh_cn',
  },
});
